import React from 'react';
import useGameStore from '../../store/gameStore';
import { getSecteur, couvertureJours } from '../../utils/retail';
import { formatMoney } from '../../utils/format';
import { Store } from 'lucide-react';

/**
 * SCD Lot 1 — Widget KPI retail du tableau de bord :
 * CA du jour, marge du jour, rotation moyenne, ruptures, démarque.
 */
export default function RetailKpiWidget() {
  const retail = useGameStore(s => s.retail);
  if (!retail) return null;
  const sec = getSecteur(retail.secteur);
  const st = retail.stats || {};
  const margePct = st.caJour > 0 ? Math.round((st.margeJour / st.caJour) * 100) : 0;

  // Rotation moyenne : couverture pondérée des familles en stock.
  const couvertures = (sec?.familles || [])
    .map(f => couvertureJours(retail.stock[f.id]?.qty || 0, retail.ventes7?.[f.id] || []))
    .filter(c => c !== 999 && c > 0);
  const rotation = couvertures.length
    ? Math.round(couvertures.reduce((a, b) => a + b, 0) / couvertures.length)
    : 0;

  const tiles = [
    { label: 'CA du jour', value: formatMoney(st.caJour || 0), testid: 'kpi-ca-jour' },
    { label: 'Marge du jour', value: `${formatMoney(st.margeJour || 0)} (${margePct} %)`, testid: 'kpi-marge-jour' },
    { label: 'Rotation moyenne', value: rotation > 0 ? `${rotation} j` : '—', testid: 'kpi-rotation' },
    { label: 'Ruptures (cumul)', value: `${st.ruptureUnitesCumul || 0} u · ${formatMoney(st.ruptureCaManqueCumul || 0)}`, warn: (st.rupturesJourUnites || 0) > 0, testid: 'kpi-ruptures' },
    { label: 'Démarque (cumul)', value: formatMoney(st.demarqueEurosCumul || 0), warn: (st.demarqueEurosCumul || 0) > 0, testid: 'kpi-demarque' },
  ];

  return (
    <div className="surface-card overflow-hidden" data-testid="retail-kpi-widget">
      <div className="px-4 py-3 border-b border-ink-600 flex items-center justify-between">
        <h3 className="font-display text-sm font-bold text-foreground tracking-tight uppercase flex items-center gap-2">
          <Store className="w-4 h-4 text-accent" /> Magasin — {sec?.nom}
        </h3>
        <span className="text-[10px] text-slate-500 font-mono">CA cumulé : {formatMoney(st.caCumul || 0)}</span>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-5 divide-x divide-ink-700/50">
        {tiles.map(tile => (
          <div key={tile.label} className="px-4 py-3" data-testid={tile.testid}>
            <p className="text-[9px] uppercase tracking-[0.14em] text-slate-500 font-mono">{tile.label}</p>
            <p className={`text-sm font-bold font-mono mt-1 ${tile.warn ? 'text-amber-400' : 'text-slate-100'}`}>{tile.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
